module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class=\'color-legend\' data-name=\'' +
((__t = ( name )) == null ? '' : __t) +
'\'>\n    <span class=\'color-box\' style=\'background-color: ' +
((__t = ( color )) == null ? '' : __t) +
'\'></span>\n    <input class=\'period-values\' name="min" type="number" value=\'' +
((__t = ( min )) == null ? '' : __t) +
'\'>\n    <input class=\'period-values\' name="max" type="number" value=\'' +
((__t = ( max )) == null ? '' : __t) +
'\'>\n    <span class=\'color-text\'>' +
((__t = ( name )) == null ? '' : __t) +
'' +
((__t = ( unit ? ' (' + unit + ')' : '' )) == null ? '' : __t) +
'</span>\n    <button data-name=\'' +
((__t = ( name )) == null ? '' : __t) +
'\'>Remove</button>\n</div>\n\n\n';

}
return __p
}